<script>
    import{ dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem, user_data } from './stores.js';
    import * as yup from 'yup'; 
    import { debounce } from 'lodash';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";

    let purchase_price = "";
    let down_payment_amount = "";
    let down_payment_percent = "";
    $: {
        if(purchase_price !== "") $user_data.purchaseprice = purchase_price.toString().replace(/[^\d.-]/g, '');
    }
    $: {
        if(down_payment_amount !== "") $user_data.downpaymentamount = down_payment_amount.toString().replace(/[^\d.-]/g, '');
    }
    $: {
        if(down_payment_percent !== "") $user_data.down_payment_percent = down_payment_percent.toString().replace(/[^\d.-]/g, '');
    }

    const formSchema = yup.object().shape({
        purchase_price_element: yup
            .string()
            .required('The purchase price is required to find the best rates.'),
        // down_payment_amount_element: yup
        // .string()
        // .required('The downpayment amount is required to find the best rates.'),
    });

    let purchase_price_element;
    let down_payment_amount_element;
    let down_payment_percent_element;


    onMount(async () => {
        setTimeout(() => {
            if($user_data.purchaseprice !== ""){
                purchase_price = $user_data.purchaseprice;
                // purchase_price_element.value = $user_data.purchaseprice;
            }
            if($user_data.downpaymentamount !== ""){
                down_payment_amount = $user_data.downpaymentamount;
            }
            if(down_payment_amount.value !== ""){
                debouncedPurchasePriceChanged();
                debouncedDownPaymentAmountChanged();
                formatEverything();
            }

        }, 200);

    });


    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ purchase_price_element: purchase_price_element.value}).then(function (value) {
            res = true;
        }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

        // check pp limit
        if(res){
            let pp = parseInt(purchase_price.toString().replace(/[^\d.-]/g, ''));
            let dp = parseInt(down_payment_amount.toString().replace(/[^\d.-]/g, ''));
            
            if(isNaN(pp)){
                pp = 0;
            }
            if(isNaN(dp)){
                dp = 0;
            }

            if((pp - dp) >= 50000 && (pp - dp) <= 2000000){
                res = true;
            }else{
                invalidateItem(purchase_price_element, 'The loan (purchase price - downpayment) must be between $50,000 and $2,000,000');
                res = false;
            }
        }

        return res;
    }

    function formatEverything(){
        dbClearAllInvalidItems();
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '').trim();
        const tdpa = down_payment_amount.toString().replace(/[^\d.-]/g, '').trim();
        const tdpp = down_payment_percent.toString().replace(/[^\d.-]/g, '').trim();

        if(tpp.length > 0){
            purchase_price = `$${tpp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
        if(tdpa.length > 0){
            down_payment_amount = `$${tdpa.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
        if(tdpp.length > 0){
            down_payment_percent = `${tdpp}%`;
        }

    }

    let debouncedPurchasePriceChanged = debounce(purchasePriceChanged, 100);
    let debouncedDownPaymentAmountChanged = debounce(downPaymentAmountChanged, 100);
    let debouncedDownPaymentPercentChanged = debounce(downPaymentPercentChanged, 100);
    let debouncedFormatter = debounce(formatEverything, 100);

    function purchasePriceChanged() {
        const tpp = purchase_price_element.value.replace(/[^\d.-]/g, '');
        const tdpa = down_payment_amount.toString().replace(/[^\d.-]/g, '');
        const tdpp = down_payment_percent.toString().replace(/[^\d.-]/g, '');

        if(parseFloat(tpp)) {
            if(parseFloat(tdpa)) {
                down_payment_percent = Math.round((parseFloat(tdpa) / parseFloat(tpp)) * 100.0);
                if(down_payment_percent > 100) down_payment_percent = 100;
            } else if(parseFloat(tdpp)) {
                down_payment_amount = Math.round(tpp * parseFloat(tdpp));
            }
        }

        debouncedFormatter();

        }

    function downPaymentAmountChanged() {
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '');
        const tdpa = down_payment_amount_element.value.toString().replace(/[^\d.-]/g, '');
        // const tdpp = down_payment_percent.toString().replace(/[^\d.-]/g, '');

        if(parseFloat(tdpa) && parseFloat(tpp)){
                down_payment_percent = Math.round((parseFloat(tdpa) / parseFloat(tpp)) * 100.0);
        }
        debouncedFormatter();

    }

    function downPaymentPercentChanged() {
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '');
        // const tdpa = down_payment_amount.toString().replace(/[^\d.-]/g, '');
        const tdpp = down_payment_percent_element.value.toString().replace(/[^\d.-]/g, '');

        if(parseFloat(tdpp) && parseFloat(tpp)){
                down_payment_amount = Math.round(parseFloat(tpp) * (1/100) * parseFloat(tdpp));
        }
        debouncedFormatter();
    }

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    pre_next_callback_function={checkNext}
    title="What's your estimated purchase price and down payment?"
    >
    <div class="pricedpcontainer">
        <div class="commentcontainer">
            Your loan amount can affect your loan program and rate.
        </div>
        <div class="purchasepricecontainer">
            <input inputmode="numeric" bind:this={purchase_price_element} on:keyup={ () => { debouncedPurchasePriceChanged();} } bind:value={purchase_price} class="progressforminput" type="text" placeholder="Purchase Price" />
        </div>
        <div class="downpaymentcontainer">
            <div class="dppricecontainer">
                <input inputmode="numeric" bind:this={down_payment_amount_element} on:keyup={ () => { debouncedDownPaymentAmountChanged();} } bind:value={down_payment_amount} class="progressforminput" type="text" placeholder="Down Payment" />
            </div>
            <div class="dppercentcontainer">
                <input inputmode="numeric" bind:this={down_payment_percent_element} on:keyup={ () => { debouncedDownPaymentPercentChanged();} } bind:value={down_payment_percent} class="progressforminput" type="text" placeholder="%" />
            </div>
        </div>
    </div>
    </Progresscomponent>

</Dtemplate>

<style>
.pricedpcontainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.commentcontainer {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    color: var(--blueslate);
    font-size: 1em;
}

.purchasepricecontainer {
    width: 40%;
    margin-left: auto;
    margin-right: auto;
}
.purchasepricecontainer input {
    width: 100%;
}
.downpaymentcontainer {
    width: 40%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    display: flex;
}
.dppricecontainer {
    flex: 3;
    padding: 0;
    margin-right: 25px;
}
.dppricecontainer input {
    border-right: solid 1px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
.dppercentcontainer {
    flex: 1;
    padding: 0;
}
.dppercentcontainer input{
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}
.dppercentcontainer input::placeholder{
    text-align: right;
}
@media (max-device-width: 1200px), (max-width: 1199px) {
    .commentcontainer {
        display: none;
    }
    .purchasepricecontainer, .downpaymentcontainer {
        width: 80% !important;
        margin-top: 30px;
    }    

}

</style>